import { render, staticRenderFns } from "./infosubs.vue?vue&type=template&id=a3533aca&"
import script from "./infosubs.vue?vue&type=script&lang=js&"
export * from "./infosubs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports